import * as Types from '@/types/schema';

import gql from 'graphql-tag';
export type ShareConfigFragment = { status: Types.ShareConfigStatusEnum, workspaceId: string, sharedAt: string, sharedById: string, sourceWorkspaceEntityId?: string | null };


export type ShareConfigFragmentVariables = Types.Exact<{ [key: string]: never; }>;

export const ShareConfigFragmentDoc = /*#__PURE__*/ gql`
    fragment ShareConfig on ShareConfig {
  status
  workspaceId
  sharedAt
  sharedById
  sourceWorkspaceEntityId
}
    `;